export const getClassificationName = (classificationValue: number) => {
  if (classificationValue === 4) {
    return "Urgent";
  }
  if (classificationValue === 3) {
    return "High";
  }
  if (classificationValue === 2) {
    return "Medium";
  }
  if (classificationValue === 1) {
    return "Low";
  }
  return "Medium";
};
